import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChange, signIn, signOutUser } from "../firebase/auth";

const AuthContext = createContext();

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (user) => {
      // Dashboard access requires the `admin` custom claim (set with
      // scripts/set-admin-claims.mjs). Any email/password account used to get
      // full access; the Firestore rules now enforce the same claim.
      let admin = false;
      if (user) {
        try {
          const result = await user.getIdTokenResult();
          admin = result.claims.admin === true;
        } catch (err) {
          console.error("Could not read admin claim:", err);
        }
      }
      setUser(user);
      setIsAdmin(admin);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    const result = await signIn(email, password);
    return result;
  };

  const logout = async () => {
    const result = await signOutUser();
    return result;
  };

  const value = {
    user,
    isAdmin,
    loading,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
